import * as React from "react";
import RegisterPaidPage from "../pages/RegisterPaid";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { URL_PATHS } from "../../src/routes";
import { useDispatch, useSelector } from "react-redux";
import { paymentActions } from "../store/payment";
import { agent } from "../agent";
import { myDataActions } from "../store/myData";
import { AppState } from "../store";
import {
    Gender,
    PaymentPlanEnum,
    PostPaidRegisterUserRequestBody,
    Prefecture
} from "../generated/UserAPIAgent";
import { smartAlert } from "../lib/confirm-alert";

/**
 * 会員登録時に有料登録を行うケースの会員登録画面
 * */
const RegisterPaidContainer = (): JSX.Element => {
    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector((state: AppState) => state.myData.user);
    const payment = useSelector((state: AppState) => state.payment);
    const [isLoading, setIsLoading] = useState(false);
    const onSubmit = async (data: {
        address: string;
        building: string;
        city: string;
        date: string;
        familyName: string;
        familyNameKana: string;
        gender: string;
        givenName: string;
        givenNameKana: string;
        month: string;
        nickname: string;
        phone: string;
        pref: number;
        year: string;
        zip: string;
    }): Promise<void> => {
        const birthday =
            data.year +
            "-" +
            ("0" + data.month).slice(-2) +
            "-" +
            ("0" + data.date).slice(-2);
        const requestBody: PostPaidRegisterUserRequestBody = {
            ...data,
            birthday: birthday,
            gender: data.gender as Gender,
            pref: Number(data.pref) as Prefecture
        };
        try {
            setIsLoading(true);
            await agent.postPaidRegisterUser(requestBody);
            dispatch(myDataActions.myDataShouldLoadSet(true));
            const paymentStatus = await agent.getPaymentStatus();
            dispatch(paymentActions.paymentStatusSet(paymentStatus));
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            await smartAlert("会員登録に失敗しました");
        }
    };
    useEffect(() => {
        if (user && payment.status) {
            const newCardPaymentPlan = payment.status.cardPaymentPlans.find(
                (plan) =>
                    plan.paymentPlanId === PaymentPlanEnum.STANDARD_1M_CARD_9800
            );
            const newCampaign =
                newCardPaymentPlan.campaigns.length > 0
                    ? newCardPaymentPlan.campaigns[0]
                    : null;
            dispatch(
                paymentActions.selectedPaymentSet({
                    paymentPlanId: PaymentPlanEnum.STANDARD_1M_CARD_9800,
                    campaignId: newCampaign ? newCampaign.campaignId : null,
                    amount: newCardPaymentPlan.amount,
                    firstAmount: newCampaign ? newCampaign.firstAmount : null
                })
            );
            dispatch(paymentActions.paymentInProgressSet(true));
            history.push(URL_PATHS.paymentMake3DS());
        }
    }, [user, payment.status]);
    return <RegisterPaidPage onSubmit={onSubmit} isLoading={isLoading} />;
};
export default RegisterPaidContainer;
